import { Card } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import PaymentMethodIcon from "../../../components/PaymentMethodIcon/PaymentMethodIcon";
import StallInfo from "../../../components/StallInfo";
import "./PaymentReceiptCard.scss";

interface IPaymentReceiptCardProps {
	companyName?: string;
	uenNumber?: string;
	gstNumber?: string;
	transactionNumber?: string;
	paymentReference?: string;
	totalAmount?: string;
	paymentMethod?: string;
	gstAmount?: string;
}

const PaymentReceiptCardWang: React.FC<IPaymentReceiptCardProps> = ({
	companyName,
	uenNumber,
	gstNumber,
	transactionNumber,
	paymentReference,
	totalAmount,
	paymentMethod,
	gstAmount,
}) => {
	const { t } = useTranslation();

	return (
		<Card className="PaymentReceiptCard CardWang">
			<div className="PaymentReceiptHeader" />

			<div className="PaymentReceiptBody">
				<StallInfo />

				<div className="ReceiptDetailsGrid">
					<div className="DetailRow">
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.companyName")}</div>
							<div className="DetailValue">{companyName || "{{company-name}}"}</div>
						</div>
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.uenNumber")}</div>
							<div className="DetailValue">{uenNumber || "{{uen-number}}"}</div>
						</div>
					</div>
					<div className="DetailRow">
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.gstNumber")}</div>
							<div className="DetailValue">{gstNumber || "{{gst-number}}"}</div>
						</div>
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.receiptNumber")}</div>
							<div className="DetailValue">{transactionNumber || "{{receiptNumber-number}}"}</div>
						</div>
					</div>
					<div className="DetailRow">
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.paymentReference")}</div>
							<div className="DetailValue">{paymentReference || "{{payment-reference}}"}</div>
						</div>
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.totalAmountWang")}</div>
							<div className="DetailValue">{totalAmount || "{{total-amount}}"}</div>
						</div>
					</div>
					<div className="DetailRow">
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.paymentMethod")}</div>
							<div className="DetailValue">
								<PaymentMethodIcon paymentMethod={paymentMethod || "{{payment-method}}"} />
							</div>
						</div>
						<div className="DetailItem">
							<div className="DetailLabel">{t("paymentReceipt.gstInfo")}</div>
							<div className="DetailValue">{gstAmount || "{{gst-amount}}"}</div>
						</div>
					</div>
				</div>
				<div className="PaymentReceiptFooter">{t("paymentReceipt.gstFooter")}</div>
			</div>
		</Card>
	);
};

export default PaymentReceiptCardWang;
